import { render, staticRenderFns } from "./compliance_terms.vue?vue&type=template&id=97b9408a&scoped=true"
import script from "./compliance_terms.vue?vue&type=script&lang=js"
export * from "./compliance_terms.vue?vue&type=script&lang=js"
import style0 from "./compliance_terms.vue?vue&type=style&index=0&id=97b9408a&prod&scoped=true&lang=scss"
import style1 from "./compliance_terms.vue?vue&type=style&index=1&id=97b9408a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b9408a",
  null
  
)

export default component.exports